<template>
	<section v-if="validRatings.length" class="main-content review-section background-light align-center">
		<div class="row">
			<div class="columns column12 align-center">
				<h2>{{ header }}</h2>
			</div>
		</div>

		<div class="row review-row">
			<div v-for="(rating, index) in validRatings" :key="index" class="columns column3 align-center reviewstat">
				<div class="imagecontainer review-source">
					<div class="logo" :class="rating.source" />
				</div>

				<strong class="score">{{ rating.score }}</strong>
				<span v-if="rating.quote?.length" class="reviewBot"> "{{ rating.quote }}" </span>
				<div>
					<strong v-if="rating.firstName?.length">{{ rating.firstName }}</strong>
					<span v-if="rating.date">
						- {{ $d(new Date(rating.date.date.split(' ')[0]), 'short', locale) }}
					</span>
				</div>
			</div>
		</div>

		<div class="row button-row">
			<div class="columns column12 align-center">
				<nuxt-link class="button button-cta" :to="localePath('reviews')">
					{{ $t('allReviews') }}
				</nuxt-link>
			</div>
		</div>
	</section>
</template>

<script setup>
const localePath = useLocalePath();

const { locale } = useI18n();

const props = defineProps({
	ratings: {
		type: Array,
		default: () => [],
	},
	header: {
		type: String,
		default: '',
	},
	content: { type: String, default: '' },
});

const validRatings = computed(() =>
	props.ratings.filter((r) => (r.score !== null && r.score !== '') || (r.quote && r.quote.trim() !== '')),
);
</script>

<style lang="scss" scoped>
.review-section {
	margin: 50px auto;
	padding: 0;
	position: relative;
	max-width: 1800px;
	overflow: hidden;
	background: none;

	&.no-top-image {
		padding-top: 50px;
		margin-top: 50px;
	}

	&.no-bottom-image {
		padding-bottom: 100px;
	}

	.row {
		position: relative;
		z-index: 1;
		margin: auto;
		display: flex;
		gap: 20px;
		flex-flow: row wrap;
		justify-content: space-around;
	}

	.column3 {
		width: calc(22% - 40px);
		margin: 20px;
		box-sizing: border-box;
		display: flex;
		flex-flow: column;
		gap: 20px;

		.score {
			font-size: 32px;
		}
	}

	.button-row {
		margin: 25px auto;
	}

	.review-source {
		display: flex;
		flex-flow: column;
		flex-wrap: wrap;
		gap: 20px;
		margin: 34px 0 0;

		.logo {
			width: 50px;
			height: 50px;
			background-size: 50px 50px;
			margin: auto;

			&.tripadvisor {
				background-image: url('~/assets/images/review-logo-tripadvisor.png');
			}

			&.bookingcom {
				background-image: url('~/assets/images/review-logo-bookingcom.png');
			}

			&.zoover {
				background-image: url('~/assets/images/review-logo-zoover.png');
			}

			&.expedia {
				background-image: url('~/assets/images/review-logo-expedia.png');
			}

			&.google {
				background-image: url('~/assets/images/review-logo-google.png');
			}

			&.hotel {
				background-image: url('~/assets/images/bw-logo.png');
			}

			&.website {
				background-image: url('~/assets/images/bw-logo.png');
			}
		}
	}
}

@media (max-width: 1080px) {
	.review-row {
		.column3 {
			width: calc(42% - 40px);
		}
	}
}

@media (max-width: 700px) {
	.review-row {
		.column3 {
			width: 80%;
			margin: 0 auto;
		}
	}
}
</style>
